import type { Entity } from '@backstage/catalog-model';
import { stringifyEntityRef } from '@backstage/catalog-model';
import { BreadcrumbConfig, BreadcrumbPartSibling } from '../../../types';
import { getDisplayName, getEntityCatalogLink } from '../../../utils';
import { GetEntityByRefCallback } from '../../../hooks';

export const resolveBreadcrumbs = async (
  entity: Entity,
  getEntityByRef: GetEntityByRefCallback,
  breadcrumbDefinitions: ReadonlyArray<BreadcrumbConfig>,
) => {
  const breadcrumbs: BreadcrumbPartSibling[] = [];

  let current: Entity | null | undefined = entity;
  let first = true;
  const handled = new Set<string>();
  while (current) {
    const ref = stringifyEntityRef(current!);
    if (handled.has(ref)) {
      break;
    }
    handled.add(ref);
    breadcrumbs.push({
      title: getDisplayName(current!),
      link: first ? undefined : getEntityCatalogLink(current!),
      current: first,
    });
    first = false;
    const extractor = breadcrumbDefinitions.find(({ entityMatcher }) =>
      entityMatcher(current!),
    )?.previousEntityExtractor;
    if (extractor) {
      const relatedRef = extractor.referenceExtractor(current);
      current = await getEntityByRef(relatedRef, {
        fallbackKind: extractor.fallbackKind,
      });
    }
  }
  return breadcrumbs.reverse();
};
